import { getDoc, setDoc, query, doc } from "firebase/firestore";
import { database } from '../firebase-config';
import { History } from './History';
export const COLLECTION = "settings";

export class Settings {
    document_reference = ""
    user = ""
    hourly_labor_rate = 0
    low_profit_index = 0
    profit_index = 0
    title_text = ""
    last_update = ""
    history = new Array()
}

export const getSettings = async (documentRef) => {
    try {
        const existingDocRef = doc(database, COLLECTION, documentRef);
        const existingDoc = await getDoc(existingDocRef);
        if (!existingDoc.exists()) {
          console.log("getSettings(): "+ documentRef + "not found!");
          return '';
        } else {
          return existingDoc;
        }
    } catch (e) {
        console.log("getSettings(): Error getting " + COLLECTION + " ref:" + documentRef);
    }
}

export function documentToSettings(existingDoc) {
    let existingSettings = new Settings();
    existingSettings.document_reference = existingDoc.id;
    existingSettings.user = existingDoc.data().user;
    existingSettings.hourly_labor_rate = existingDoc.data().hourly_labor_rate;
    existingSettings.low_profit_index = existingDoc.data().low_profit_index;
    existingSettings.profit_index = existingDoc.data().profit_index;
    existingSettings.title_text = existingDoc.data().title_text;
    existingSettings.last_update = existingDoc.data().last_update;
    existingSettings.history = existingDoc.data().history;

    return existingSettings;
}

export const saveSettings = async (docRef, settingsData) => {
    try {
        await setDoc(doc(database, COLLECTION, docRef), settingsData, { merge: true });
    } catch (e) {
        console.log("Error saving " + COLLECTION + ":", e);
    }
}

/**
* ------------ Start History ----------------
*/
export const getHistoryRecord = async (history_key) => {
    const existingHistoryRef = doc(database, "history", history_key);
    const existingHistory = await getDoc(existingHistoryRef);
    const historyRecord = new History();
    historyRecord.key = history_key;
    historyRecord.updateDate = existingHistory.data().last_updated;
    historyRecord.field = existingHistory.data().field;
    historyRecord.oldValue = existingHistory.data().oldValue;
    historyRecord.newValue = existingHistory.data().newValue;
    return historyRecord;
  }
  
  export const loadHistoryMap = async (historyList) => {
    const map = new Map();
    for (const history_key of historyList) {
      try {
        let historyRecord = await getHistoryRecord(history_key);
        map.set(history_key, historyRecord);
      } catch (e) {
        console.log("Error getting history ref:" + history_key + " exception:" + e);
      }
    }
    return map;
  }
  
  function addHistory(newHistoryList, now, settingsName, field, oldValue, newValue) {
    let docData = {
      last_updated: now,
      field: field,
      oldValue: oldValue,
      newValue: newValue,
    };
  
    let documentName = 'settings_' + settingsName + '_' + field + "_" + now;
  
    try {
      setDoc(doc(database, "history", documentName), docData);
    } catch (e) {
      console.log("Error saving History:", e);
      return;
    }
  
    newHistoryList.push(documentName);
  }
  
  function productsEqual(newPackaging, oldPackaging) {
    if (newPackaging.length !== oldPackaging.length) return false;
    for (let ii = 0; ii < newPackaging.length; ii++) {
      if (newPackaging[ii] !== oldPackaging[ii]) return false;
    }
    return true;
  }
  
  export const recordHistory = async (newHistoryList, now, newSettings, docRef) => {
    let existingDoc = "";
    try {
      let oldDocRef = doc(database, COLLECTION, docRef);
      existingDoc = await getDoc(oldDocRef);
    } catch (e) {
      console.log("Error getting existing Settings for History:", e);
    }
  
    try {
      if (newSettings.hourly_labor_rate !== existingDoc.data().hourly_labor_rate) {
        addHistory(newHistoryList, now, docRef, "hourly_labor_rate", existingDoc.data().hourly_labor_rate,newSettings.hourly_labor_rate);
      }
      if (newSettings.low_profit_index !== existingDoc.data().low_profit_index) {
        addHistory(newHistoryList, now, docRef, "low_profit_index", existingDoc.data().low_profit_index,newSettings.low_profit_index);
      }
      if (newSettings.title_text !== existingDoc.data().title_text) {
        addHistory(newHistoryList, now, docRef, "title_text", existingDoc.data().title_text,newSettings.title_text);
      }
      if (!productsEqual(newSettings.profit_index, existingDoc.data().profit_index)) {
        addHistory(newHistoryList, now, docRef, "profit_index", existingDoc.data().profit_index, newSettings.profit_index);
      }
      
    } catch (e) {
      console.log("Error getting document ref:" + this.props.docRef);
    }
  }
  /**
   * ------------ End History ----------------
   */
